import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  getTravelProductTypeStart,
  getTravelProductTypeSuccess,
  getTravelProductTypeFailure,
} from "../reducers/getTravelProductTypeReducer";
import axios from "axios";
import Cookies from "js-cookie";

export const getTravelProductType = createAsyncThunk(
  "getTravelProductType",
  async (_, thunkAPI) => {
    try {
      thunkAPI.dispatch(getTravelProductTypeStart());
      const token = Cookies.get("token");

      const response = await axios.get(
        `${process.env.REACT_APP_BASE_URL}api/Travel/GettravelProductType`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const responseData = await response;

      thunkAPI.dispatch(
        getTravelProductTypeSuccess(responseData?.data?.result)
      );

      return responseData;
    } catch (error) {
      thunkAPI.dispatch(
        getTravelProductTypeFailure(error.response.data.Message)
      );

      throw error;
    }
  }
);
